import {LOG_DOC_TYPE, LOG_DOC_TYPE_MAP} from './const';

export function average(values: number[]) {
    const sum = values.reduce((previous, current) => {
        return current + previous;
    });
    return sum / values.length;
}

export function getLogDocType(curDocument?: WizDocument): string {
    return LOG_DOC_TYPE_MAP[curDocument?.type as number] || LOG_DOC_TYPE.doc;
}
